import { render } from "./newHikVideo.vue?vue&type=template&id=1501495c&scoped=true"
import script from "./newHikVideo.vue?vue&type=script&lang=js"
export * from "./newHikVideo.vue?vue&type=script&lang=js"

import "./newHikVideo.vue?vue&type=style&index=0&id=1501495c&lang=less&scoped=true"

import exportComponent from "/jenkins/workspace/zh-operate-subapp_prev/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1501495c"]])

export default __exports__